
import React, { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { TerraceSubmission } from "@/types";

import StatusFilter from "./submissions/StatusFilter";
import SubmissionsTable from "./submissions/SubmissionsTable";
import SubmissionDetailDialog from "./submissions/SubmissionDetailDialog";
import SubmissionSearch from "./submissions/SubmissionSearch";
import DeleteConfirmationDialog from "./submissions/DeleteConfirmationDialog";
import { useSubmissions } from "./submissions/useSubmissions";
import { useSubmissionActions } from "./submissions/useSubmissionActions";

const SubmissionsManager = () => {
  const [statusFilter, setStatusFilter] = useState<'all' | 'pending' | 'approved' | 'rejected'>('pending');
  const [searchTerm, setSearchTerm] = useState("");
  
  const { submissions, isLoading, fetchSubmissions } = useSubmissions(statusFilter);
  const { 
    selectedSubmission,
    isDialogOpen,
    setIsDialogOpen,
    form,
    handleViewSubmission,
    handleApprove,
    handleReject,
    handleDeleteRequest,
    deleteDialogOpen,
    setDeleteDialogOpen,
    submissionToDelete,
    handleConfirmDelete,
    isDeleting,
  } = useSubmissionActions(fetchSubmissions);

  const handleApproveFromTable = (submission: TerraceSubmission) => {
    handleViewSubmission(submission);
    handleApprove();
  };

  const handleRejectFromTable = (submission: TerraceSubmission) => {
    handleViewSubmission(submission);
    handleReject();
  };

  const filteredSubmissions = submissions.filter(sub => 
    sub.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="space-y-4 sm:space-y-6">
      <div className="flex flex-col space-y-4 sm:flex-row sm:justify-between sm:items-center sm:space-y-0 sm:gap-4">
        <StatusFilter 
          statusFilter={statusFilter} 
          setStatusFilter={setStatusFilter} 
        />
        
        <SubmissionSearch 
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
        />
      </div>

      <Card>
        <CardContent className="p-0">
          <SubmissionsTable
            submissions={filteredSubmissions}
            isLoading={isLoading}
            handleViewSubmission={handleViewSubmission}
            handleApproveFromTable={handleApproveFromTable}
            handleRejectFromTable={handleRejectFromTable}
            handleDeleteFromTable={handleDeleteRequest}
            statusFilter={statusFilter}
          />
        </CardContent>
      </Card>

      <SubmissionDetailDialog
        isOpen={isDialogOpen}
        setIsOpen={setIsDialogOpen}
        selectedSubmission={selectedSubmission}
        form={form}
        handleApprove={handleApprove}
        handleReject={handleReject}
      />

      <DeleteConfirmationDialog
        isOpen={deleteDialogOpen}
        onOpenChange={setDeleteDialogOpen}
        submission={submissionToDelete}
        onConfirm={handleConfirmDelete}
        isDeleting={isDeleting}
      />
    </div>
  );
};

export default SubmissionsManager;
